<template>
  <v-container fill-height>
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              mdi-school
            </v-icon>
            <span class="title">Data Pengajuan Beasiswa</span>
          </v-card-title>
          <v-tabs
            v-model="tabsurat"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              List Pengajuan
              <v-icon large>playlist_add_check</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>playlist_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabsurat">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="4">
                        <v-select
                          :items="liststatus"
                          name="statussurat"
                          v-model="filter.status"
                          label="Status"
                          @change="getSurat">
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="8">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.changest">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.tanggal_surat`]="{ item }">
                            {{ item.tanggal_surat | dateToAge }}
                          </template>
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              :to="{ name: 'SuratDetailMhs', params: { kodesurat: item.id_bs }}"
                              small
                              icon>
                              <v-icon>search</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <div class="text-center" v-if="loading.getprofile">
                      <v-progress-circular
                        :width="3"
                        color="red"
                        indeterminate>
                      </v-progress-circular>
                    </div>
                    <v-row justify="center" v-if="profile">
                      <v-col cols="12" md="7">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Data Profile
                            </div>
                          </v-col>
                          <v-col cols="12" md="3">
                            <span class="text-subtitle-1">NIM</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.nim ? profile.nim : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="5">
                            <span class="text-subtitle-1">Nama</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.nama ? profile.nama : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">IPK</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.ipk ? profile.ipk : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="3">
                            <span class="text-subtitle-1">Jurusan</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.jurusan ? profile.jurusan : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="5">
                            <span class="text-subtitle-1">Prodi</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.prodi ? profile.prodi : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Jenjang</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.jenjang ? profile.jenjang : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="3">
                            <span class="text-subtitle-1">Tanggal Lahir</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.jenjang ? profile.jenjang : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="5">
                            <span class="text-subtitle-1">Tempat Lahir</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.tmpLahir ? profile.tmpLahir : '-' }}
                            </h2>
                          </v-col>
                          <v-col cols="12" md="4">
                            <span class="text-subtitle-1">Kelamin</span>
                            <h2 class="subtitle-1 font-weight-bold mb-3">
                              {{ profile.jenisKelamin ? profile.jenisKelamin : '-' | kelaminParse }}
                            </h2>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col cols="12" md="5">
                        <v-row class="black--text">
                          <v-col cols="12" md="12">
                            <div class="title font-weight-bold text-decoration-underline">
                              Data Beasiswa
                            </div>
                          </v-col>
                        </v-row>
                        <alertsp :alertdata="alertdata"></alertsp>
                        <v-form
                          @submit.prevent="submitAdd"
                          ref="formaddsurat"
                          v-model="formadd.valid"
                          lazy-validation>
                          <v-row justify="center" no-gutters>
                            <v-col cols="12" md="12">
                              <v-row>
                                <v-col cols="12">
                                  <v-autocomplete
                                    name="jenisbeasiswa"
                                    v-model="addsurat.jenis_bs"
                                    :items="listjenisbeasiswa"
                                    item-value="id_jb"
                                    item-text="nama_jb"
                                    return-object
                                    @change="updateJenisBeasiswa"
                                    label="Jenis Beasiswa">
                                  </v-autocomplete>
                                </v-col>
                                <v-col cols="12">
                                  <v-file-input
                                    v-model="addsurat.f_spdir"
                                    :rules="rules.files"
                                    accept=".pdf"
                                    name="filespdir"
                                    placeholder="Select file"
                                    label="Surat permohonan direktur"
                                    show-size>
                                  </v-file-input>
                                </v-col>
                                <v-col cols="12">
                                  <v-file-input
                                    v-model="addsurat.f_prestasi"
                                    :rules="rules.files"
                                    accept=".pdf"
                                    name="fileprestasi"
                                    placeholder="Select file"
                                    label="Piagam atau bukti prestasi"
                                    show-size>
                                  </v-file-input>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <v-checkbox
                                    v-model="checkbox"
                                    :rules="[v => !!v || 'Setujui untuk melanjutkan!']"
                                    :label="'Sebagai ' + username"
                                    required>
                                  </v-checkbox>
                                </v-col>
                              </v-row>
                              <v-row>
                                <v-col cols="12">
                                  <div class="text-center" v-if="loading.addsurat">
                                    <v-progress-circular
                                      :width="3"
                                      color="red"
                                      indeterminate>
                                    </v-progress-circular>
                                  </div>
                                  <v-btn
                                    v-if="!loading.addsurat"
                                    large
                                    block
                                    :disabled="!formadd.valid"
                                    color="success"
                                    class="mr-4 mt-5"
                                    type="submit">
                                    Ajukan
                                  </v-btn>
                                </v-col>
                              </v-row>
                            </v-col>
                          </v-row>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';
import { sha256, sha224 } from 'js-sha256';

export default {
  name: 'SuratGuest',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      changest: false,
      addsurat: false,
      getprofile: false,
    },
    api: process.env.VUE_APP_API,
    apision: process.env.VUE_APP_APISION,
    hash: process.env.VUE_APP_HASH,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    modulklian: process.env.VUE_APP_MOD_KLIAN,
    liststatus: ['permohonan', 'penilaian', 'lulus', 'gagal', 'semua'],
    filter: {
      search: '',
      status: 'permohonan',
    },
    checkbox: true,
    headers: [
      { text: 'Periode', value: 'period_bs' },
      { text: 'Beasiswa', value: 'nama_jb' },
      { text: 'NIM', value: 'user_bs' },
      { text: 'Tanggal', value: 'tgl_bs' },
      { text: 'Status', value: 'status_bs' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    listjenisbeasiswa: [],
    addsurat: {
      jenis_bs: '',
      period_bs: '',
      p_nama: '',
      p_jurusan: '',
      p_prodi: '',
      p_jenjang: '',
      p_kelas: '',
      p_ipk: '',
      p_tgllahir: '',
      p_tempatlahir: '',
      p_kelamin: '',
      f_spdir: null,
      f_gaji: null,
      f_kk: null,
      f_prestasi: null,
      f_sportu: null,
      f_tabungan: null,
    },
    formadd: {
      password: false,
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => (v) && v.length >= 8 || 'Min 8 characters',
      nik: (v) => (v) && v.length >= 16 || 'Min 16 characters',
      files: [
        (value) => !value || value.size < 5000000 || 'Files less than 5 MB!',
        (value) => !!value || 'Required.',
      ],
    },
    tabsurat: null,
    profile: null,
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
      'username',
      'usernik',
    ]),
  },
  mounted() {
    // get data param
    if (this.$route.query.type && this.$route.query.type !== '') {
      this.filter.status = this.$route.query.type;
    }
    // klian
    if (this.modulklian === '1') {
      this.liststatus = ['accbanjar', 'permohonan', 'proses', 'siap', 'selesai', 'batal', 'semua'];
      // this.filter.status = this.liststatus[0];
    }
    // init request
    this.getSurat();
    this.getJenisBeasiswa();
    this.getProfile();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
    kelaminParse(value) {
      return value === 'L' || value === 'l' ? 'Laki-Laki' : 'Perempuan';
    },
  },
  methods: {
    updateJenisBeasiswa(data) {
      this.addsurat.jenis_bs = data.id_jb;
      this.addsurat.period_bs = data.period_jb;
    },
    getJenisBeasiswa() {
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisbeasiswa/',
            {
              params: {
                status: 'active',
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.listjenisbeasiswa = resdata.data;
                // default
                this.addsurat.jenis_bs = resdata.data[0].id_jb;
                this.addsurat.period_bs = resdata.data[0].period_jb;
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getSurat() {
      if (this.tokenscr) {
        this.loading.changest = true;
        this.axios
          .get(
            this.api + '/api/beasiswa/',
            {
              params: {
                status: this.filter.status,
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.changest = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.changest = false;
          });
      }
    },
    getProfile() {
      this.loading.getprofile = true;
      const strhex = this.usernik +
        '' + this.hash;
      const hashactv = sha256(strhex).toUpperCase();
      this.axios
        .get(
          this.apision + '/mahasiswa/' + this.usernik + '&' + hashactv,
          {
            params: {},
            headers: {},
          },
        )
        .then((res) => {
          if (res.status === 200) {
            const resdata = res.data;
            // console.log(resdata);
            if (resdata.responseCode === '00') {
              this.profile = resdata.profile;
              this.addsurat.p_nama = resdata.profile.nama;
              this.addsurat.p_jurusan = resdata.profile.jurusan;
              this.addsurat.p_prodi = resdata.profile.prodi;
              this.addsurat.p_jenjang = resdata.profile.jenjang;
              this.addsurat.p_tgllahir = resdata.profile.tglLahir;
              this.addsurat.p_tempatlahir = resdata.profile.tmpLahir;
              this.addsurat.p_kelamin = resdata.profile.jenisKelamin;
              this.addsurat.p_ipk = resdata.profile.ipk;
            }
          }
          this.loading.getprofile = false;
        })
        .catch((error) => {
          console.log(error);
          this.loading.getprofile = false;
        });
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddsurat.validate()) {
        if (this.tokenscr) {
          this.loading.addsurat = true;
          const dataadd = this.addsurat;
          const formData = new FormData();
          // file
          formData.append('f_gaji', dataadd.f_gaji);
          formData.append('f_kk', dataadd.f_kk);
          formData.append('f_prestasi', dataadd.f_prestasi);
          formData.append('f_spdir', dataadd.f_spdir);
          formData.append('f_sportu', dataadd.f_sportu);
          formData.append('f_tabungan', dataadd.f_tabungan);
          // text
          formData.append('jenis_bs', dataadd.jenis_bs);
          formData.append('p_ipk', dataadd.p_ipk);
          formData.append('p_jenjang', dataadd.p_jenjang);
          formData.append('p_jurusan', dataadd.p_jurusan);
          formData.append('p_kelamin', dataadd.p_kelamin);
          formData.append('p_kelas', dataadd.p_kelas);
          formData.append('p_nama', dataadd.p_nama);
          formData.append('p_prodi', dataadd.p_prodi);
          formData.append('p_tempatlahir', dataadd.p_tempatlahir);
          formData.append('p_tgllahir', dataadd.p_tgllahir);
          formData.append('period_bs', dataadd.period_bs);
          console.log(this.addsurat);
          // request
          this.axios
            .post(
              this.api + '/api/beasiswa/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                // console.log(resdata);
                if (resdata.error === false) {
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Beasiswa a/n "' + this.addsurat.p_nama + '" berhasil diajukan!';
                  this.getSurat();
                  this.$root.$emit('app-getnotifiaction');
                  this.$refs.formaddsurat.reset();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
              this.loading.addsurat = false;
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
              this.loading.addsurat = false;
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .text-underline{
    text-decoration: underline;
  }
  .border-solid-thin{
    border: solid thin #f1f1f1;
  }
</style>
